class RoleController extends AbstractEntityEditController
	@register()
	@inject '$scope',
		'$timeout'
		'ConfigurationList'
		'role'
		'models'
		'rights'
		'UserRoleRepository'
		'ConfigurationService'
		'ConfigurationValueRepository'
		'Guid'
		'CopyService'
		'BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE'
		'ConfigurationRepository'

	initialize: ->
		@mainCrud.entityType = 'general.role'
		@mainCrud.isNewEntity = !@role.id?

		@mainCrud.showDelete = @ConfigurationService.isEnabled 'Backoffice.RoleManagement.EnableRoleDeletion'
		@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.RoleManagement.EnableRoleCreation'

		@dataRights = []
		@showFullRightsInfo = false
		@selectedRights = []
		@actions = [
			'read'
			'create'
			'update'
			'delete'
		]
		@configsFilter = [
			'Backoffice.'
			'!Backoffice.AccountManagement'
			'!Backoffice.RegisterManagement'
			'!Backoffice.Sales'
			'!Backoffice.Setting'
			'!Backoffice.Theme'
			'!Backoffice.TopMenu.Setting.Configurations'
			'!Backoffice.Home'
			'Pos.'
			'Shared.'
			'!Shared.Receipt.Logo.ImageFile'
			'!Shared.Payment.Fiskaly.Enabled'
		]
		@defaultDisabledRights = ['WM_RIGHT_OVERRIDE_PRICES_ON_LINE_ITEMS']

		@mainCrud.tabs = [
			{
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'wbo.tab.data_rights'
				selector: '#tab-data-rights'
			}
			{
				title: 'wbo.tab.rights'
				selector: '#tab-rights'
			}
			{
				id: 'role-configurations'
				title: 'wbo.tab.configuration'
				disabled: @mainCrud.isNewEntity
				selector: '#tab-configuration'
			}
		]

		@mainCrud.entityType = 'general.role'
		@mainCrud.entityTitle = 'wbo.new.role'

		if !@mainCrud.isNewEntity
			@mainCrud.additionalButtons = [
				{
					action: 'copy'
					label: 'general.copy'
					confirmClick: => @copy()
					confirmClickLabel: 'general.copy.confirm'
				}
			]

			@mainCrud.entityTitle = @role.name
			@mainCrud.showSave = @ConfigurationService.isEnabled "Backoffice.RoleManagement.EnableRoleEdit"
		else
			@role =
				id: @Guid.generate()
				models: []
				rights: []

		@MessageTerminal.on @$scope,
			@MessageTerminal.events.TAB_CHANGE
			(tab) =>
				@mainCrud.showFormActionButtons = tab.id != 'role-configurations'

		@initRights()
		@initDataRights()

	save: ->
		@mainCrud.saving = true

		@UserRoleRepository
			.save @getRoleForSaving(), @mainCrud.isNewEntity
			.then (response) =>
				@role = response.data

				@initDataRights()
				@afterSave response
			.catch (result) =>
				@handleErrors result

	delete: ->
		@deleteEntity @UserRoleRepository, @role

	getRoleForSaving: ->
		return {
			id: @role.id
			name: @role.name
			data_rights: @getFinalDataRights()
			rights: @getFinalRights()
		}

	getFinalRights: ->
		return _.chain(@selectedRights)
			.filter({selected: true})
			.pluck('id')
			.value()

	getFinalDataRights: ->
		dataRights = _.filter @dataRights, (dataRight) -> dataRight.id? or dataRight.dirty

		return _.map dataRights, (dataRight) =>
			return {
				id: if dataRight.id? then dataRight.id else null
				model_id: dataRight.model_id.toUpperCase()
				role_id: @role.id
				can_list: dataRight.read
				can_view: dataRight.read
				can_update: dataRight.update
				can_create: dataRight.create
				can_delete: dataRight.delete
			}

	initRights: ->
		for right in @rights
			@selectedRights.push angular.extend(
				{},
				right,
				{
					selected: (@mainCrud.isNewEntity && !@defaultDisabledRights.includes(right.id)) || @role.rights.includes(right.id)
				}
			)

	initDataRights: ->
		@dataRights = []

		angular.forEach @models, (model, index) =>
			model = angular.copy model

			if @role.models[index]?
				model = @role.models[index]

			dataRight =
				id: model.data_rights.id
				model_name: model.model_name
				model_id: model.model_id
				dirty: false
				restrict: model.restrict
			# Deny reading field only if List and View are denied
			dataRight.restrict.read = dataRight.restrict.list && dataRight.restrict.view

			angular.forEach @actions, (action) =>
				dataRight[action] = @getInitialValue model, action

			@setDataRightToggleState dataRight

			@dataRights.push dataRight

	getInitialValue: (dataRight, action) ->
		if action == 'read'
			# If at least one of List or View is enabled, then allow read
			return @getInitialValue(dataRight, 'list') || @getInitialValue(dataRight, 'view')
		else
			return !dataRight.restrict[action] && (dataRight.data_rights[action] || !dataRight.data_rights[action]?)

	setDataRightToggleState: (dataRight) ->
		states = []

		angular.forEach @actions, (action) ->
			if dataRight.restrict[action] == false
				states.push dataRight[action]

		arraySum = states.reduce(
			(total, state) ->
				total + state
			, 0
		)

		dataRight.toggleState = states.length == arraySum

	checkAllDataRights: (state) ->
		@mainCrud.parent_form.$setDirty()

		angular.forEach @dataRights, (dataRight) =>
			@$timeout(
				=>
					dataRight.toggleState = state
					@toggleDataRight(dataRight)
				, 0
			)

	toggleDataRight: (dataRight) ->
		state = dataRight.toggleState == true

		angular.forEach @actions, (action) =>
			@toggleDataRightAction dataRight, state, action

	toggleDataRightAction: (dataRight, state, action) ->
		if dataRight.restrict[action] == false
			dataRight[action] = state

			dataRight.dirty = true

		@setDataRightToggleState dataRight

	copy: ->
		if @mainCrud.isNewEntity
			console.warn('Can not copy new entity')

			return

		role = @getRoleForSaving()
		copiedRole = @CopyService.copyEntity(role, data_rights: ['role_id'])

		@mainCrud.saving = true

		@UserRoleRepository
			.save copiedRole, true
			.then (response) =>
				@copyRoleConfigurations(role.id, response.data.id)
					.then =>
						@afterSave response
					.catch (result) =>
						@handleErrors result
			.catch (result) =>
				@handleErrors result

	copyRoleConfigurations: (originalRoleId, copiedRoleId) ->
		@ConfigurationRepository
			.listRoleConfigurations(originalRoleId)
			.then (configurations) =>
				configurationPromises = []

				for item in configurations
					if item.owner_id != originalRoleId || item.type != @BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE.ROLE
						continue

					configurationCopy = angular.extend {}, item, id: null
					promise = @ConfigurationValueRepository.saveByContext configurationCopy, 'roles', copiedRoleId
					configurationPromises.push promise

				@ConfigurationValueRepository.all(configurationPromises)
